<template>
  <div>
    <!-- Header -->
    <HeaderComponent @login="onLogin" />

    <!-- Prediction Cards List -->
    <PredictionCardsList :initialVisibleCount="6" />
  </div>
</template>

<script>
import HeaderComponent from '../components/HeaderComponent.vue';
import PredictionCardsList from '../components/PredictionCardsList.vue';

export default {
  name: 'IndexPage',
  components: {
    HeaderComponent,
    PredictionCardsList
  },
  setup(props, { emit }) {
    const onLogin = () => {
      // Page-specific login handling if needed
      console.log('Login event received in Index page');
    };

    return {
      onLogin
    };
  }
};
</script>
<style scoped>
  body {
    background-color: #f9fafb;
  }
</style>